import _ from 'lodash';
import angular from 'angular';
import logger from '../../../shared/logger';
import { POSITION_EVENT_FLOW_TYPES, POSITION_EVENTS } from '../../../constants/positionEvents';

export const JOB_WIZARD_EVENT_STEPS = [
    POSITION_EVENTS.createJob,
    POSITION_EVENTS.editJob,
    POSITION_EVENTS.chooseSamples,
    POSITION_EVENTS.tips,
    POSITION_EVENTS.preliminaryFeedback,
    POSITION_EVENTS.complete,
];

export const PositionEventsService =
    ($stateParams, PositionService, permissions) => {
        const scrape_requested = 'scrape_requested';
        const scrape_completed = 'scrape_completed';
        const scrape_bypassed = 'scrape_bypassed';

        const ACTIVATE = 'ACTIVATE';
        const RE_ACTIVATE = 'RE_ACTIVATE';
        const CANCEL = 'CANCEL';// Cancel
        const ACTIVATE_JOB = 'ACTIVATE_JOB';
        const CLOSE_JOB = 'CLOSE_JOB';
        const CLONE_JOB = 'CLONE_JOB'; // Clone Job
        const DELETE_JOB = 'DELETE_JOB';// Delete Job
        const EDIT_JOB = 'EDIT_JOB'; // Edit Job
        const REQUEST_SCRAPE = 'REQUEST_SCRAPE';// Request Scrape
        const REQUEST_SCRAPE_AGAIN = 'REQUEST_SCRAPE_AGAIN';// Request Scrape Again
        const SCRAPE_COMPLETE = 'SCRAPE_COMPLETE'; // Scrape Complete
        const TE = 'TE';
        const TALENYA = 'TALENYA';
        const Ready = 'Ready';
        const Draft = 'Draft';
        const Active = 'Active';
        const Finished = 'Finished';
        const Cancelled = 'Cancelled';
        const ANY = 'ANY';
        const Employer = 'Employer';

        const employerConditions = [
            [TE, Draft, ANY, ANY, EDIT_JOB, [DELETE_JOB]],
            [TE, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TE, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TE, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TE, Ready, scrape_requested, null, ACTIVATE, [REQUEST_SCRAPE_AGAIN, CLONE_JOB, CANCEL]],
            [TE, Ready, scrape_bypassed, null, ACTIVATE, [REQUEST_SCRAPE, CLONE_JOB, CANCEL]],
            [TE, Ready, scrape_completed, null, ACTIVATE, [REQUEST_SCRAPE_AGAIN, CLONE_JOB, CANCEL]],
            [TE, Active, null, null, REQUEST_SCRAPE, [CLONE_JOB, CANCEL]],
            [TE, Active, scrape_requested, null, CANCEL, [REQUEST_SCRAPE_AGAIN, CLONE_JOB]],
            [TE, Active, scrape_bypassed, null, CANCEL, [REQUEST_SCRAPE, CLONE_JOB]],
            [TE, Active, scrape_completed, null, CANCEL, [REQUEST_SCRAPE_AGAIN, CLONE_JOB]],
            [TE, Finished, ANY, null, null, [CLONE_JOB]],
            [TE, Cancelled, ANY, null, RE_ACTIVATE, [CLONE_JOB]],
            [TALENYA, Draft, ANY, ANY, EDIT_JOB, [DELETE_JOB]],
            [TALENYA, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TALENYA, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TALENYA, Ready, null, null, REQUEST_SCRAPE, [ACTIVATE, CLONE_JOB, CANCEL]],
            [TALENYA, Ready, scrape_requested, null, SCRAPE_COMPLETE, [ACTIVATE, REQUEST_SCRAPE_AGAIN, CLONE_JOB, CANCEL]],
            [TALENYA, Ready, scrape_bypassed, null, ACTIVATE, [REQUEST_SCRAPE, CLONE_JOB, CANCEL]],
            [TALENYA, Ready, scrape_completed, null, ACTIVATE, [REQUEST_SCRAPE_AGAIN, CLONE_JOB, CANCEL]],
            [TALENYA, Active, null, null, REQUEST_SCRAPE, [CLONE_JOB, CANCEL]],
            [TALENYA, Active, null, null, REQUEST_SCRAPE, [CLONE_JOB, CANCEL]],
            [TALENYA, Active, null, null, REQUEST_SCRAPE, [CLONE_JOB, CANCEL]],
            [TALENYA, Active, scrape_requested, null, SCRAPE_COMPLETE, [CLONE_JOB, CANCEL]],
            [TALENYA, Active, scrape_bypassed, null, CANCEL, [REQUEST_SCRAPE, CLONE_JOB]],
            [TALENYA, Active, scrape_completed, null, CANCEL, [REQUEST_SCRAPE_AGAIN, CLONE_JOB]],
            [TALENYA, Finished, ANY, null, null, [CLONE_JOB]],
            [TALENYA, Cancelled, ANY, null, RE_ACTIVATE, [CLONE_JOB]],

            [Employer, Draft, ANY, ANY, EDIT_JOB, [DELETE_JOB]],
            [Employer, Ready, ANY, ANY, ACTIVATE, [CLONE_JOB, CANCEL]],
            [Employer, Active, ANY, ANY, CLOSE_JOB, [CLONE_JOB]],
            [Employer, Finished, ANY, ANY, null, [CLONE_JOB]],
            [Employer, Cancelled, ANY, ANY, ACTIVATE_JOB, [CLONE_JOB]],
        ];

        const getEmployerCondition = (positionData) => {
            const jobStatus = positionData.status;
            const jobState = jobStatus.current;
            const scrapeEvents = (positionData.events || []).filter(item => item.flowType === 'scrape');
            const scrapeLastEvent = scrapeEvents.length > 0 ? scrapeEvents[scrapeEvents.length - 1].eventType : null;
            let role = null;

            if (permissions.isTalenyaUser()) {
                role = TALENYA;
            }
            if (permissions.isTalentExpertUser()) {
                role = TE;
            }
            if (permissions.isEmployerUser()) {
                role = Employer;
            }

            const targetCondition = employerConditions.find((el) => {
                const [_role, _jobState, _scrapeLastEvent] = el;
                const isTarget = (_role === role)
                    && (_jobState.indexOf(jobState) > -1)
                    && (scrapeLastEvent === _scrapeLastEvent || _scrapeLastEvent === 'ANY');

                return isTarget;
            });

            if (!targetCondition) {
                logger.error('Not found call for action for position');
                return;
            }

            return targetCondition;
        };

        const recruiterConditions = [
            ['TE,TALENYA', 'Draft,Ready,Active,Finished,Cancelled', null, 'ANY', 'ANY', 'CLAIM', ['CLONE_JOB']],
            ['TE,TALENYA', 'Draft,Ready,Active', 'Claimed', null, null, 'REQUEST_SCRAPE', ['UN_CLAIM', 'CLONE_JOB']],
            ['TE,TALENYA', 'Draft,Ready,Active', 'Claimed', scrape_requested, null, 'UN_CLAIM', ['REQUEST_SCRAPE_AGAIN', 'CLONE_JOB']],
            ['TE,TALENYA', 'Draft,Ready,Active', 'Claimed', scrape_bypassed, null, 'UN_CLAIM', ['REQUEST_SCRAPE', 'CLONE_JOB']],
            ['TE,TALENYA', 'Draft,Ready,Active', 'Claimed', scrape_completed, null, 'UN_CLAIM', ['REQUEST_SCRAPE_AGAIN', 'CLONE_JOB']],
            ['TE,TALENYA', 'Finished,Cancelled', 'Claimed', 'ANY', null, 'UN_CLAIM', ['CLONE_JOB']],
        ];

        const getRecruiterCondition = (positionData) => {
            const jobStatusObj = positionData.status;
            const { recruiterStatus } = positionData;
            const jobStatus = jobStatusObj.current;
            const scrapeEvents = (positionData.events || []).filter(item => item.flowType === 'scrape');
            const scrapeLastEvent = scrapeEvents.length > 0 ? scrapeEvents[scrapeEvents.length - 1].eventType : null;
            const role = permissions.isTalenyaUser() ? 'TALENYA' : permissions.isTalentExpertUser() ? 'TE,TALENYA' : permissions.isEmployerUser() ? 'EM' : null;

            const targetCondition = recruiterConditions.find((el) => {
                const [_roles, _jobStatuses, _teJobState, _scrapeLastEvent] = el;
                const isTarget = (_roles.indexOf(role) > -1)
                    && (_jobStatuses.indexOf(jobStatus) > -1)
                    && (recruiterStatus === _teJobState)
                    && (scrapeLastEvent === _scrapeLastEvent || _scrapeLastEvent === 'ANY');

                return isTarget;
            });

            if (!targetCondition) {
                logger.error('Not found call for action for position');
                return;
            }

            return [...targetCondition].reverse();
        };

        const isCompleteJobDefinitionRequestAvailable = (position) => {
            const wizardEvents = (position.events || []).filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.positionWizard);
            const isCompleteMessageWizardEventExist = (position.events || [])
                .find(({ eventType, flowType }) => eventType === POSITION_EVENTS.complete && flowType === POSITION_EVENT_FLOW_TYPES.positionWizard);

            if (wizardEvents.length === 0 || !isCompleteMessageWizardEventExist) {
                const feedbackEvents = (position.events || []).filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.feedback);
                const isFeedbackRequested = (feedbackEvents || []).find(({ eventType }) => eventType === POSITION_EVENTS.feedbackRequested);

                return !isFeedbackRequested;
            }

            return false;
        };

        const isCompleteJobDefinitionAvailable = (position) => {
            const isClosedPosition = ['Cancelled', 'Finished'].includes(position.status.current);

            if (isClosedPosition) {
                return false;
            }

            const wizardEvents = _.filter(position.events, ({ eventType, flowType }) =>
                (flowType === POSITION_EVENT_FLOW_TYPES.positionWizard) && JOB_WIZARD_EVENT_STEPS.includes(eventType));

            const isJobDefinitionAlreadyCompleted = _.get(wizardEvents, `${wizardEvents.length - 1}.eventType`, null) === POSITION_EVENTS.complete;

            if (wizardEvents.length > 0 && !isJobDefinitionAlreadyCompleted) {
                return !_(position.events)
                    .filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.feedback)
                    .find(({ eventType }) => eventType === POSITION_EVENTS.feedbackRequested);
            }

            return false;
        };

        const requestScrape = async (positionData, requesterUserData) => {
            const { _id: positionId, employerId } = positionData;
            const { result } = await PositionService.setPositionEvent({
                positionId,
                flowType: 'scrape',
                eventType: 'scrape_requested',
                recruiterId: requesterUserData._id,
                employerId,
                content: {
                    message: `User ${requesterUserData.fullName} requested scrape`,
                },
            });
            return result;
        };

        const completeScrape = async (positionData, requesterUserData) => {
            const { _id: positionId, employerId } = positionData;
            const { result } = await PositionService.setPositionEvent({
                positionId,
                flowType: 'scrape',
                eventType: 'scrape_completed',
                recruiterId: requesterUserData._id,
                employerId,
                content: {
                    message: `User ${requesterUserData.fullName} completed scrape`,
                },
            });

            return result;
        };

        const insightSent = async (positionData, requesterUserData) => {
            const { _id: positionId, employerId } = positionData;
            const { result } = await PositionService.setPositionEvent({
                positionId,
                flowType: POSITION_EVENT_FLOW_TYPES.insight,
                eventType: POSITION_EVENTS.insightSent,
                recruiterId: requesterUserData._id,
                employerId,
                content: {
                    message: `User ${requesterUserData.fullName || requesterUserData.name} sent Insight report`,
                },
            });

            return result;
        };

        const isSendFeedbackToEmployerAvailable = (position) => {
            const wizardEvents = (position.events || []).filter(({ flowType }) => flowType === POSITION_EVENT_FLOW_TYPES.positionWizard);

            return _.get(wizardEvents, `${wizardEvents.length - 1}.eventType`, null) === POSITION_EVENTS.complete;
        };

        const addWizardCreateJobEvent = async (positionData, requesterUserData) => {
            const { _id: positionId, employerId, recruiterId } = positionData;
            const { result } = await PositionService.setPositionEvent({
                positionId,
                flowType: POSITION_EVENT_FLOW_TYPES.positionWizard,
                eventType: POSITION_EVENTS.createJob,
                recruiterId,
                employerId,
                content: {
                    message: `User ${requesterUserData.fullName || requesterUserData.name} create job`,
                },
            });

            return result;
        };

        return {
            getRecruiterCondition,
            requestScrape,
            insightSent,
            completeScrape,
            addWizardCreateJobEvent,
            getEmployerCondition,
            isCompleteJobDefinitionAvailable,
            isCompleteJobDefinitionRequestAvailable,
            isSendFeedbackToEmployerAvailable,
        };
    };


angular
    .module('TALENYA-FE')
    .factory('PositionEventsService', PositionEventsService);
